import { render, staticRenderFns } from "./DisplayLargeScreen.vue?vue&type=template&id=5db2e2ad&scoped=true&"
import script from "./DisplayLargeScreen.vue?vue&type=script&lang=js&"
export * from "./DisplayLargeScreen.vue?vue&type=script&lang=js&"
import style0 from "./DisplayLargeScreen.vue?vue&type=style&index=0&id=5db2e2ad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2e2ad",
  null
  
)

export default component.exports